import { Component, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { bonusQueueTrx, clientAreaTrx } from 'src/app/router-translation.labels';
import { CloseDialogButtonComponent } from 'src/app/components/dialog/close-dialog-button/close-dialog-button.component';

export interface FirstLossBonusDialogData {
  body?: string;
  bodyHtml?: string;
  ctaText?: string;
  heroSrc?: string;
}

@Component({
  selector: 'app-first-loss-bonus-dialog',
  standalone: true,
  imports: [CommonModule, FlexLayoutModule, CloseDialogButtonComponent],
  templateUrl: './first-loss-bonus-dialog.component.html',
  styleUrls: ['./first-loss-bonus-dialog.component.scss']
})
export class FirstLossBonusDialogComponent {
  readonly heroSrc: string;
  readonly body: string;
  readonly bodyHtml?: string;
  readonly ctaText: string;

  constructor(
    public dialogRef: MatDialogRef<FirstLossBonusDialogComponent>,
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) data: FirstLossBonusDialogData | null,
  ) {
    this.heroSrc = data?.heroSrc || 'assets/gamification/extra-bonus/wallet.png';
    this.body = data?.body || $localize`:@@first-loss-bonus-body:Hey! Don´t leave with a sour taste. A 10$ bonus is ready for you to claim!`;
    this.bodyHtml = data?.bodyHtml || $localize`:@@first-loss-bonus-body-html:<p>Hey! Don´t leave with a sour taste.</p><p>A <strong>10$ BONUS</strong></p><p>is ready for you to claim!</p>`;
    this.ctaText = data?.ctaText || $localize`:@@first-loss-bonus-cta:Claim`;
  }

  claim(): void {
    this.router.navigate(['', clientAreaTrx, bonusQueueTrx]);
    this.dialogRef.close();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
